import { createAsyncThunk } from "@reduxjs/toolkit";
import { memberApi } from "api/memberVip";
import { MemberPayload } from "types/memberVip";

export const getMemberVip = createAsyncThunk(
  "member/getVipMember",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const response = await memberApi.getMemberVip(data.username, data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const getMemberAward = createAsyncThunk(
  "member/MemberAward",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const response = await memberApi.getMemberAward(data.username, data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
